{
      "repositories" : [
    {
        "branch":  "qa",
        "url":  "https://gitlab.cs.nl/van-vliet-containers/pm/tree/874f7b8085a8beacf1288b53703078bbb1d9c5a9",
        "displayName":  "CDP",
        "tag":  "",
        "lastCommitHash":  "874f7b8085a8beacf1288b53703078bbb1d9c5a9"
    },
    {
        "branch":  "HEAD",
        "url":  "https://Teamcity_VVL@gitlab.cs.nl/cs/cohelion/pm-core/tree/208f8f5b3091230a00077f91d947b4bb526d66c5",
        "displayName":  "pm-core",
        "tag":  "",
        "lastCommitHash":  "208f8f5b3091230a00077f91d947b4bb526d66c5"
    },
    {
        "branch":  "HEAD",
        "url":  "https://Teamcity_VVL@gitlab.cs.nl/cs/performancemanager/performance-manager-seed/tree/6725f9ea4c9e609f5486fd758765101dc76c8515",
        "displayName":  "cdp-client",
        "tag":  "",
        "lastCommitHash":  "6725f9ea4c9e609f5486fd758765101dc76c8515"
    }
],
      "buildDate"	: "2026-10-19T15:58+0200",
    "detailsUrl"	: "http://teamcity/buildConfiguration/VVL_Cdp_Client_Qa/95497?buildTab=changes&showFiles=false&expandRevisionsSection=false",
    "version": "7.18.0",
    "libs": {
    "@cs/about":  "1.2.0",
    "@cs/assistant":  "1.7.7"
}
  }